module.exports = __webpack_public_path__ + "static/media/volley_icon.8672d4c3.svg";